import { jsxs as i, jsx as s } from "react/jsx-runtime";
import _ from "classnames";
const c = "forma-ui__fill-group__root", u = "forma-ui__fill-group__head", m = "forma-ui__fill-group__name", f = "forma-ui__fill-group__buttons", d = "forma-ui__fill-group__content", h = "forma-ui__fill-group__progress", p = "forma-ui__fill-group__bar", g = "forma-ui__fill-group__half", o = {
  root: c,
  head: u,
  name: m,
  buttons: f,
  content: d,
  progress: h,
  bar: p,
  half: g
}, b = ({ id: t, className: e, children: n, title: a, buttons: l, percent: r }) => /* @__PURE__ */ i("div", { className: _(o.root, e), children: [
  /* @__PURE__ */ s("input", { type: "hidden", autoFocus: !0 }),
  (a || l) && /* @__PURE__ */ i("div", { className: o.head, children: [
    a && /* @__PURE__ */ s("div", { className: o.name, children: a }),
    l && /* @__PURE__ */ s("div", { className: o.buttons, children: l })
  ] }),
  /* @__PURE__ */ i("div", { className: o.content, id: t, children: [
    (r || r === 0) && /* @__PURE__ */ s("div", { className: o.progress, children: /* @__PURE__ */ s("div", { className: _(o.bar, r < 100 && o.half), style: { width: `${r}%` } }) }),
    n
  ] })
] });
export {
  b as default
};
